<template lang="pug">
  .column.is-one-half-mobile.is-one-half-tablet.is-one-quarter-desktop.is-one-quarter-widescreen.is-one-quarter-fullhd
    .card
      header.card-header
        p.card-header-title
          small {{ convetirNombre(esfera.id)}}
      .card-content
        .columns.is-mobile
          .column.is-5
            .wrapper
              .greenEsf
                .progressEsfd
                  .inner
                    #pbPor1d.percent
                      span {{ esfera.porcentaje}}
                      | %
                    .water
                    .glare
          .column.is-7
            p.card-content-esf-tit
              | P. Domo: 
              span.card-content-esf
                | {{parseFloat(esfera.presionDomo).toFixed(2)}}
                small kg/cm²
            p.card-content-esf-tit
              | P. Fondo: 
              span.card-content-esf
                | {{parseFloat(esfera.presionFondo).toFixed(2)}}
                small kg/cm²
            p.card-content-esf-tit
              | Dens. 
              span.card-content-esf
                | {{parseFloat(esfera.densidad).toFixed(2)}}
                small kg/m³
            p.card-content-esf-tit
              | Dens. C. 
              span.card-content-esf
                | {{parseFloat(esfera.densidad20).toFixed(2)}}
                small kg/m³
            p.card-content-esf-tit
              | Masa: 
              span.card-content-esf
                | {{parseFloat(esfera.masa).toFixed(2)}}
                small Ton.
        .columns.is-mobile
          .column.is-6
            p.card-content-esf-tit
              | Temp. 
              span.card-content-esf
                | {{parseFloat(esfera.temperatura).toFixed(2)}}
                small °C
            p.card-content-esf-tit
              | Vol. 
              span.card-content-esf
                | {{parseFloat(esfera.volumen).toFixed(3)}}
                small m³
            p.card-content-esf-tit
              | Nivel: 
              span.card-content-esf
                | {{parseFloat(esfera.nivel).toFixed(1)}}
                small m
          .column.is-6
            p.card-content-esf-tit
              | Vol. B. 
              span.card-content-esf
                | {{parseFloat(esfera.volumenBarril).toFixed(3)}}
                small bbl.
            p.card-content-esf-tit
              | Vol20: 
              span.card-content-esf
                | {{parseFloat(esfera.volumen20).toFixed(3)}}
                small m³
            p.card-content-esf-tit
              | Vol20 B. 
              span.card-content-esf
                | {{parseFloat(esfera.volumen20Barril).toFixed(3)}}
                small bbl.

</template>


<script>
  export default {
    name: 'card_Esferas',
    props: {
      esfera: {
        type: Object
      },
    },
    methods: {
      iniciarComponente() {
        
      },
      convetirNombre(id) {
        let inicio = id.substring(0, 2)
        let final = id.substring(2, 6)
        return `${inicio}-${final}`
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>
  @import '../../../scss/esferas.css';

 .card-content-esf{
  font-weight: 600;
  color: #057d8d;
  }

  .card-content-esf-tit {
    font-weight: 600;
    color: #54545c !important;
    font-size: 14px;
  }

  .card-header-title {
    margin-bottom: 0;
    font-size: 20px;
    color: #54545c;
    font-weight: 600;
    padding: 0.5rem;
  }

  .card-header {
    box-shadow: none;
  }

  .card-content {
    padding: 0.5rem;
  }

  @media (min-width:320px) and (orientation: landscape)  { 
    .card-content-esf{
      font-weight: 600;
      color: #057d8d;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/estaciones_Componentes/layouts/card_Esfera.vue